export default __webpack_public_path__ + "static/1-6e21a70432baf28561a55afaf25726b3.webp";